import { useMemo } from 'react';
import { useSwrData } from './swrWrapper';


// TODO: needs to be refactored, has been used in way too many places to update
export const useFetchInstructors = token => {
	

	const url = token
		? `${import.meta.env.VITE_APP_API_URL}/admin/instructor/get-all`
		: null;
	const swrKey = useMemo(() => 
		url ? { url, token } : null, 
		[url, token]
	);

	const { data, error } = useSwrData(swrKey?.url, swrKey?.token);

	return {
		instructors: data?.data || [],
		isLoading: !error && !data,
		isError: error,
		key: url
	};
};
